import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'

import { IFeeSchedule } from './feeSchedule'
import { ODataService } from 'common-services'

export interface IProcedureCodeFee extends IModelBase {
  Amount?: number
  PercentageBilled?: number
  Code: string
  Modifier: string
  Description: string
  FeeScheduleId: number
  FeeSchedule: IFeeSchedule
  AccountingCode: string
}

@Injectable()
export class ProcedureCodeFeeODataService extends ODataService<IProcedureCodeFee> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProcedureCodeFees'
  }
}
